import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from "@/api/PMS/report/dailyReport.js";
import waves from "@/directive/waves"; // 水波纹指令

import { formatJson } from "@/utils/index";
export default {
  name: "DailyReport",
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {// page: 1,
        // limit: 10
      },
      dates: [],
      multipleSelection: [],
      initDate: []
    };
  },
  watch: {},
  created: function created() {
    this.defaultDate(); // 获取路由的配置

    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.listQuery.appType = parseInt(appType);
    }

    this.getList();
  },
  methods: {
    arraySpanMethod: function arraySpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex === this.list.length - 1) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    getPrecision: function getPrecision(num) {
      var str = String(num);
      var decimalIndex = str.indexOf('.');
      return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
    },
    add: function add(a, b) {
      var precision = Math.max(this.getPrecision(a), this.getPrecision(b));
      var multiplier = Math.pow(10, precision);
      return (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
    },
    getSummaries: function getSummaries(_ref2) {
      var _this = this;

      var columns = _ref2.columns,
          data = _ref2.data;
      var result = columns.map(function (column, index) {
        if (index === 0) {
          var _index = data && data.length > 0 ? data.length + 1 : 0;

          return _index;
        }

        if (index === 1) {
          return '合计';
        } else {
          var values = data.map(function (item) {
            return Number(item[column.property]);
          });

          if (values.every(function (value) {
            return isNaN(value);
          })) {
            return '-'; // 如果是NaN，返回'-'或其他默认值
          }

          var sum = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return _this.add(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          return sum;
        }
      });
      return result;
    },
    checkRange: function checkRange() {
      if (this.dates) {
        var dayCount = this.getDayCount(this.dates[0], this.dates[1]);

        if (dayCount > 61) {
          this.dates = this.initDate;
          this.Alert({
            alertType: "error",
            message: "查询时间段不能超过61天，时间段已重置为本月"
          });
        }
      }
    },
    getDayCount: function getDayCount(start, end) {
      var startDate = new Date(start);
      var endDate = new Date(end);
      return Math.abs(endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
    },
    // 初始化默认时间
    defaultDate: function defaultDate() {
      var date = new Date();
      var year = date.getFullYear().toString();
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
      var day = new Date(date.getFullYear(), month, 0).getDate();
      day < 10 ? '0' + day.toString() : day.toString();
      var beg = year + '-' + month + '-01';
      var end = year + '-' + month + '-' + day;
      this.initDate = [beg, end];
      this.dates = this.initDate;
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this2.list = response.data.data;
        _this2.total = response.data.total;
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      // this.listQuery.page = 1;
      this.getList();
    },
    // handleSizeChange (val) {
    //   this.listQuery.limit = val;
    //   this.getList();
    // },
    // handleCurrentChange (val) {
    //   this.listQuery.page = val;
    //   this.getList();
    // },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    handleExport: function handleExport() {
      var _this3 = this;

      this.exLists = [];
      this.$confirm("你确定要导出订单每日统计报表吗, 是否继续?", "提示").then(function () {
        var beginDate = "";
        var endDate = "";

        if (_this3.dates !== null && _this3.dates.length > 0) {
          beginDate = _this3.dates[0];
          endDate = _this3.dates[1];
        }

        fetchList({
          endDate: endDate,
          beginDate: beginDate
        }).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            var arrayWithIndex = list.map(function (item, index) {
              var settleDate = item.settleDate,
                  orderAmount = item.orderAmount,
                  refundAmount = item.refundAmount;
              var a = {
                index: index + 1,
                settleDate: settleDate,
                orderAmount: orderAmount,
                refundAmount: refundAmount
              };
              return a;
            });

            var _orderAmount = arrayWithIndex.reduce(function (sum, item) {
              return _this3.add(sum, item.orderAmount);
            }, 0);

            var _refundAmount = arrayWithIndex.reduce(function (sum, item) {
              return _this3.add(sum, item.refundAmount);
            }, 0);

            var obj = null;
            obj = {
              index: arrayWithIndex.length + 1,
              settleDate: "合计",
              orderAmount: _orderAmount,
              refundAmount: _refundAmount
            };
            arrayWithIndex.push(obj);
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["序号", "结算日期", "支付结算金额（元）", "退款结算金额（元）"];
              var fileterVal = ["index", "settleDate", "orderAmount", "refundAmount"];
              var multiHeader = [["订单每日统计报表", "", "", ""]];
              var merges = ["A1:D1"];
              var data = formatJson(fileterVal, arrayWithIndex);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                merges: merges,
                multiHeader: multiHeader,
                filename: "订单每日统计报表",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this3.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};